import Header from '../../../shared/Header';
import { Box, Flex, Stack } from '../../../shared/layouts';
import { useTheme } from '@emotion/react';
import { useMediaQuery } from '@dnhb/node_package';
import Card from '../../../shared/Card';
import Button from '../../../shared/Button';
import { useTranslation } from 'react-i18next';
import ScanQrIcon from 'imagesUwKluis/svg/scan_qr.svg';
import FastIcon from 'imagesUwKluis/svg/dual/fast.svg';
import SafeIcon from 'imagesUwKluis/svg/dual/safe.svg';
import ReliableIcon from 'imagesUwKluis/svg/dual/reliable.svg';
import QrIcon from 'imagesUwKluis/svg/dual/qr.svg';
import CollectIcon from 'imagesUwKluis/svg/dual/collect.svg';
import ApprovalIcon from 'imagesUwKluis/svg/dual/approval.svg';
import styled from '@emotion/styled';

const InfoColumns = styled(Flex)(({ theme }) => ({
  justifyContent: 'space-between',
  alignContent: 'stretch',
  padding: '16px 0',
  gap: '32px',
  '> div, > div > div': {
    gap: '32px',
    flex: '1 0 80px',
  },
  strong: {
    display: 'block'
  },
  svg: {
    display: 'block',
    width: '80px',
    height: '80px',
    '[class*=primary]': { fill: theme?.colors?.primary },
    '[class*=secondary]': { fill: theme?.colors?.secondary },
  }
}));

const IntroSection = ({ sourceType, setIsPrepared }) => {
  const { t } = useTranslation();
  const { breakpoints } = useTheme();
  const isMinDesktop = useMediaQuery(
    `(min-width: ${breakpoints.ml ?? '56.25rem'})`
  );
  const { app_name, logo } = sourceType;

  return (
    <Card>
      <Stack space={'m'}>
        <Header
          icon={<ScanQrIcon />}
          button={isMinDesktop && logo}
          title={t('Brondataverzoek')}
          variant="section"
          width={'100%'}
        />
        <Box>
          {t(
            'Met de {{app_name}} app bespaar je een hoop uitzoektijd. Je weet zeker dat je veilig, snel en betrouwbaar met je DigiD de juiste informatie aanlevert van Belastingdienst, MijnOverheid, Mijnpensioenoverzicht, DUO en UWV.',
            { app_name }
          )}
        </Box>
        <InfoColumns
          flexDirection={{ mobile: 'column', tablet: 'row' }}
        >
          <Flex flexDirection={{ mobile: 'row', tablet: 'column' }}>
            <FastIcon />
            <Box>
              <strong>{t('Snel')}</strong>
              <span>
                {t(
                  'Met jouw toestemming verzamelen we alleen de data die echt nodig is.'
                )}
              </span>
            </Box>
          </Flex>
          <Flex flexDirection={{ mobile: 'row', tablet: 'column' }}>
            <SafeIcon />
            <Box>
              <strong>{t('Veilig')}</strong>
              <span>
                  {t(
                    '{{app_name}} versleutelt je gegevens, waardoor niemand anders ze kan inzien.',
                    { app_name }
                  )}
              </span>
            </Box>
          </Flex>
          <Flex flexDirection={{ mobile: 'row', tablet: 'column' }}>
            <ReliableIcon />
            <Box>
              <strong>{t('Betrouwbaar')}</strong>
              <span>
                {t(
                  '{{app_name}} bewaart jouw data tijdelijk volgens de hoogste veiligheidseisen. Je adviseur gebruikt de data alleen met jouw toestemming.',
                  { app_name }
                )}
              </span>
            </Box>
          </Flex>
        </InfoColumns>
        <Box py={'m'} borderTop={'default'}>
          <strong>{t('Hoe werkt het?')}</strong>
          <InfoColumns flexDirection={{ mobile: 'column', desktop: 'row' }}>
            <Flex flexDirection={{ mobile: 'row', tablet: 'column' }}>
              <QrIcon />
              <Box>
                <strong>{t('1. Scan de QR-code')}</strong>
                <span>
                   {t(
                     'Scan de QR-code met de camera van je telefoon of direct in de {{app_name}} app.',
                     { app_name }
                   )}
                </span>
              </Box>
            </Flex>
            <Flex flexDirection={{ mobile: 'row', tablet: 'column' }}>

            <CollectIcon />
              <Box>
                <strong>{t('2. Verzamel informatie')}</strong>
                <span>
                {t(
                  'Haal data op bij de verschillende overheidsinstanties door in te loggen met je DigiD.'
                )}
              </span>
              </Box>
            </Flex>
            <Flex flexDirection={{ mobile: 'row', tablet: 'column' }}>

            <ApprovalIcon />
              <Box>
                <strong>{t('3. Geef toestemming')}</strong>
                <span>
                  {t(
                    'Zie welke data er is opgehaald. Alleen met jouw toestemming deel je de data met je adviseur.'
                  )}
                </span>
              </Box>
            </Flex>
          </InfoColumns>
        </Box>
        <Flex justifyContent={'center'}>
          <Button
            onClick={() => setIsPrepared(true)}
            width={isMinDesktop ? null : '100%'}
          >
            {t('Start brondataverzoek')}
          </Button>
        </Flex>
      </Stack>
    </Card>
  );
};

export default IntroSection;
